import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class DashboardPiasConventionServiceV2 {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getDashboardPiasConvention(targetYear: number) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardNewPiasConvention;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": this.sessionStorageService.getCurrentRepCode().toString(),
        "ReportYear": targetYear
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
